module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Date":"Дата","Category":"Категория","Description":"Описание","now":"сейчас","future_planned_trs":"Планы","sum_and_balance":"Сумма и Будущий Баланс","more":"ещё"},"en":{"future_planned_trs":"Planned Transactions","sum_and_balance":"Amount and Future Balance","more":"display more"}}')
  delete Component.options._Ctor
}
